import React from 'react';
import './TopBanner.css';

const TopBanner = () => {
  const text = 'Find clarity with AstroIndia';
  
  const BannerContent = () => (
    <div className="banner-content-block">
      <span className="banner-text">{text}</span>
      <svg className="banner-icon-sun" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="5" fill="currentColor"/>
        <path d="M12 2V4M12 20V22M4 12H2M22 12H20M19.07 4.93L17.66 6.34M6.34 17.66L4.93 19.07M19.07 19.07L17.66 17.66M6.34 6.34L4.93 4.93" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      </svg>
      
      <span className="banner-text">{text}</span>
      <div className="banner-dots">
        <div className="banner-dot"></div>
        <div className="banner-dot"></div>
        <div className="banner-dot"></div>
      </div>
      <span className="banner-text">{text}</span>
      <svg className="banner-icon-sun" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" fill="currentColor"/>
      </svg>
    </div>
  );

  return (
    <div className="top-banner">
      <div className="banner-marquee">
        <BannerContent />
        <BannerContent />
        <BannerContent />
      </div>
    </div>
  );
};

export default TopBanner;

